class DesignData {
    constructor() {
        this.cod = "";
        this.nomeCalculo = "";
        this.nomeCalculadora = "";
        this.tipo = 0;
        this.autor = "";
        this.emailAutor = "";
        this.dataCriacao = "";
        this.codProjeto = "";
        this.dataUltimaMovimentacao = "";

        this.jobName = "";
        this.jobNumber = "";
        this.tagNumber = "";
        this.equipmentDescription = "";
        this.client = "";
        this.documentNumber = "";
        this.preparedBy = "";
        this.checkedBy = "";
        this.approvedBy = "";
        this.reviewDate = "";
        this.designInternalPressure = 0;
        this.maxOperationPressure = 0;
        this.designExternalPressure = 0;
        this.designTemperature = 0;
        this.roomTemperature = 0;
        this.fluid = "";
        this.density = 0;
        this.corrosionAllowance = 0;
        this.position = "";
        this.volume = 0;
        this.lengthBetweenTangents = 0;
        this.radiography = "";
        this.postWeldHeatTreatment = "";
        this.fluidClass = "";
        this.pv = "-";
        this.potentialRiskGroup = "";
        this.categoryNR13 = "";
    }
}

export default DesignData;
